define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/query",
	"dojo/store/Memory",
	"dijit/registry",
	"dgrid/extensions/DijitRegistry",
	"dgrid/OnDemandGrid",
	"dgrid/editor",
	"csi/_base/underscore",
	"csi/locale",
	"csi/reflection",
	"csi/widget/CheckBox",
	"csi/xml",
	"csi/view/Widget"
], function(declare, lang, query, Memory, registry, GridDijitRegistry, OnDemandGrid, editor, _, locale, reflection, CheckBox, xml, ViewWidget) {

	return declare(ViewWidget, {
		ATTRIBUTES: {
			editable: "ReadOnlyViews",
			visible: "HiddenViews"
		},

		EDIT_ATTRIBUTES: {
			editable: "canDisable",
			visible: "canHide"
		},

		_buildView: function() {
			// summary: create and set store based on plugin parameters

			var node = this.getViewNode();
			var items = [];

			for (var name in node) {
				if (node.hasOwnProperty(name) && name.indexOf("AdobePLMConnectViewPermission") >= 0) {
					var item = {
						id: name,
						name: locale.resource(name),
						hasName: (name != null),
						visible: node[name] > 0 ? true : false,
						editable: node[name] == 2 ? true : false,
						canHide: true,
						canDisable: true
					};
					items.push(item);
				}
			}

			var collection = new Memory({
				data: items
			});

			if (this._grid) {
				this._grid.set("store", collection);
			} else {
				this._grid = new (declare([OnDemandGrid, GridDijitRegistry]))({
					"class": "csi-grid-tableView csi-grid-adobe-permissions",
					showFooter: true,
					query: {parent: null},
					store: collection,
					columns: [
						{
							className: "left",
							field: "name",
							label: locale.resource("View"),
							sortable: false
						},
						editor({
							autoSave: true,
							canEdit: function(obj) {
								this.editorArgs.disabled = !obj.canHide;
								return true;
							},
							className: "csi-grid-checkbox",
							editor: CheckBox,
							editorArgs: {},
							field: "visible",
							label: locale.resource("Visible"),
							sortable: false
						}),
						editor({
							autoSave: true,
							canEdit: function(obj) {
								this.editorArgs.disabled = !obj.canDisable || !obj.visible;
								return true;
							},
							className: "csi-grid-checkbox",
							editor: CheckBox,
							editorArgs: {},
							field: "editable",
							label: locale.resource("Editable"),
							sortable: false
						})
					]
				}, this.contentNode);

				this._grid.on("dgrid-datachange", lang.hitch(this, this._onDataChange));
			}

			this.inherited(arguments);
		},

		_onDataChange: function(evt) {
			// summary: if flag changed on internal node, trigger behavior
			var b = evt.value;
			var attr = evt.cell.column.field;
			var item = evt.cell.row.data;

			var grid = this._grid;

			// apply changes
			var attrId = this.ATTRIBUTES[attr];
			var bVisible = (attrId == this.ATTRIBUTES.visible);

			var cbs;
			var vcb;
			var ecb;
			var row = grid.row(item.id);
			if (row.element) {
				cbs = query(".dijitCheckBox", row.element);
				vcb = registry.byNode(cbs[0]);
				ecb = registry.byNode(cbs[1]);

				if (bVisible) {
					// update value of visibile cb and disabled status of editable cb
					vcb.set("value", b, false);
					if (!b)
						ecb.set("value", b, false);
					ecb.set("disabled", !b || !item.canDisable);
				} else {
					// update value of editable cb
					ecb.set("value", b, false);
				}
			} else {
				// If there is no row element, end
				return;
			}

			// publish change to server
			var url = reflection.URL_COMPANY;
			var nodeAttr = evt.rowId;

			this.writeOperations((writer) => {
				writer.changeNode(url).changeAttribute(nodeAttr, xml.ATTR_INTEGER, ecb.checked + vcb.checked);
			});
		}
	});
});